import React, {useContext} from "react"
import AuthStreamBase from "@irati/auth/streams/auth/base"

interface AuthContextValue {
  authed: AuthStreamBase<any>
  unauthed: AuthStreamBase<any>
}

export const AuthContext = React.createContext<AuthContextValue | null>(null)

export function useAuthContext(): AuthContextValue {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error("useAuthContext must be used inside AuthProvider")
  return ctx
}
